export default __webpack_public_path__ + "static/macbook-21eb6eaf0f562f202aac9f93b64ec4e0.svg";